import { render, staticRenderFns } from "./thresholds-tab.vue?vue&type=template&id=71c03b93"
import script from "./thresholds-tab.vue?vue&type=script&lang=ts"
export * from "./thresholds-tab.vue?vue&type=script&lang=ts"
import style0 from "./thresholds-tab.vue?vue&type=style&index=0&id=71c03b93&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c03b93')) {
      api.createRecord('71c03b93', component.options)
    } else {
      api.reload('71c03b93', component.options)
    }
    module.hot.accept("./thresholds-tab.vue?vue&type=template&id=71c03b93", function () {
      api.rerender('71c03b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/thresholds-tab/thresholds-tab.vue"
export default component.exports